module.exports = "<div class=\"overlay\">\n  <div class=\"content\">\n    <div class=\"button__close\" (click)=\"emitClose()\">\n      <i class=\"fa fa-close\"></i>\n    </div>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/popup/popup.component.html
// module id = ../../../../../src/app/components/popup/popup.component.html
// module chunks = main